import mqtt from 'mqtt';
import EventBus from "../common/EventBus.js";

const MQTTService = {
  client: null,
  mqttUser: null,
  mqttPwd: null,
  raceTeam: null,
  initialTopics: null,
  lastMsgDate: 0,

  connect(selectedCombinations) {
    if (this.mqttUser == null || this.mqttPwd == null || this.mqttUser === "" || this.mqttPwd === "") {
      console.log("MQTTService / connect / user/pwd not set");
      return;
    }

    this.client = mqtt.connect('wss://smartelec.eu.org:8084/mqtt', {
      clientId: 'react_client_' + Math.random().toString(16).substr(2, 8),
      // clean: true,
      connectTimeout: 4000,
      reconnectPeriod : 1000,
      resubscribe : true,
      username: this.mqttUser,
      password: this.mqttPwd,
    });

    this.client.on('connect', () => {
      console.log('MQTTService / Connected to EMQX!');
      // this.subscribe('raceteam/' + this.raceTeam + "/#");

      if (this.initialTopics) {
        this.initialTopics.map((topic) => {
          this.subscribe(topic)
        })
      }
    });

    this.client.on('message', (topic, message) => {
      // Assuming the message is in a JSON format
      const parsedMessage = JSON.parse(message.toString());
      // console.log("MQTTService / btwn msgs", Date.now() - this.lastMsgDate, "ms / since ble", Date.now() - parsedMessage.timestamp);
      this.lastMsgDate = Date.now();

      // console.log('MQTTService / Received message:', parsedMessage);
      if (topic.includes("rtdata"))
        EventBus.dispatch('mqttRaceRtData', { topic, parsedMessage });
      if (topic.includes("laps"))
        EventBus.dispatch('mqttRaceLaps', { topic, parsedMessage });
    });

    this.client.on('error', (err) => {
      console.error('MQTTService / Connection error:', err);
      this.client.end();
    });

    this.client.on('reconnect', () => {
      console.log('MQTTService / Reconnecting...');
    });

    this.client.on('disconnected', () => {
      console.log('MQTTService / disconnected ' + new Date())
    })

    this.client.on('offline', () => {
      console.log('MQTTService / Client is offline');
    });

    this.client.on("packetreceive", () => {
      this.client.pingResp = true;
    });
  },

  setUserAndPassword(user, pwd, race_team) {
    console.log("MQTTService / setPassword user/pwd/race_team", user, pwd, race_team);
    this.mqttUser = user;
    this.mqttPwd = pwd;
    this.raceTeam = race_team;
  },

  async subscribe(topic) {
    if (this.client) {
      await this.client.subscribe(topic, { qos: 0 }, (error) => {
        if (error) {
          console.log('MQTTService / Subscribe error:', error);
          return;
        }
        console.log(`MQTTService / Subscribed to topic ${topic}`);
      });
    } else {
      console.warn('MQTTService / Subscribe error: client is null');
    }
  },

  async unsubscribe(topic) {
    if (this.client) {
      await this.client.unsubscribe(topic, { qos: 0 }, (error) => {
        if (error) {
          console.log('MQTTService / Unsubscribe error:', error);
          return;
        }
        console.log(`MQTTService / Unsubscribe to topic ${topic}`);
      });
    } else {
      console.warn('MQTTService / Unsubscribe error: client is null');
    }
  },

  async setTopics(topics) {
    this.initialTopics = topics;
    if (this.client) {
      for (const topic of topics) {
        await this.subscribe(topic);
      }
    }
  },


  disconnect() {
    if (this.client != null) {
      this.client.end(() => {
        console.log('MQTTService / Disconnected from EMQX');
      });
    }
  },
};

export default MQTTService;
